import React from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';

const StatusCell = ({ dataKey, orDataKey, rowData, ...props }) => (
  <Table.Cell {...props}>
    {get(orDataKey, rowData) || get(dataKey, rowData)}
  </Table.Cell>
);

StatusCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  orDataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

StatusCell.defaultProps = {
  rowData: null
};

export default StatusCell;
